import axiosInstance from "./axiosInstance";

export const obtenerTitularesPost = async (id) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/obtenerTitularesPost?id=${id}`,
    { withCredentials: true }
  );
};
